export default __webpack_public_path__ + "static/clients06-4bff8bb96ca4e3d5392bd1b23b495c40.svg";